export const sideBarConstants = {
	CHANGE_STEP: 'CHANGE_STEP',
	INFO_BOX_HIDDEN: 'INFO_BOX_HIDDEN',
	INFO_BOX_OPEN: 'INFO_BOX_OPEN',
	OPEN_CLOSE_SIDE_BAR: 'OPEN_CLOSE_SIDE_BAR'
};
